// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import PageNavbarController from '../../components/page/navbar_component/navbar_controller';
import LiveDashboardController from './live_dashboard_controller';

application.register('page--navbar', PageNavbarController);
application.register('live-dashboard', LiveDashboardController);
